module.exports = __webpack_public_path__ + "static/dalia-pugatsch-video-79f0aa8cd4c834847af52f11e99ba590.mp4";